module.exports = require("./mni-Beng.d.ts");